import * as Config from '../../../config';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import './LeftBarContainer.css';

import LogoSection from '../custom/-APP_TARGET/content/LogoSection';
import GroupButtons from './GroupButtons';
import Playlists from './Playlists';
import PartyMode from '../partymode/LeftBlock';
import FilterPlaylistsInput from './FilterPlaylistsInput';
import SettingsSection from './SettingsSection';
import InformationSection from './InformationSection';
import MyPlaylistsMenuSection from './MyPlaylistsMenuSection';

import useManageGroup from './hooks/useManageGroup';

function ConnectedLeftBarContainer({
  height, style, showInfoSection, isConnected
}) {
  const [valueFilterPlaylist, setValueFilterPlaylist] = useState('');
  const onChangeValueFilterPlaylist = (e) => setValueFilterPlaylist(e.target.value);
  const clear = () => setValueFilterPlaylist(``);

  const { showGroup, accessGroup } = useManageGroup();

  return (
    <div className={`flexColumn left-bar-container`} style={{ ...style, width: Config.SIDE_WIDTH, maxHeight: height - Config.LEFT_PAD_TOP, overflow: 'hidden' }}>
      <LogoSection />

      <GroupButtons>
        <div className={`group-button type-medium fz13 ${ showGroup === 0 && 'selected' }`} onClick={accessGroup(0)}>My Library</div>
        <div className={`group-button type-medium fz13 ${ showGroup === 1 && 'selected' }`} onClick={accessGroup(1)}>B2B Mode</div>
      </GroupButtons>

      {showGroup === 0 && <MyPlaylistsMenuSection />}

      <div className={'flexColumn'} style={{ overflow: 'hidden' }}>
        <div className={'flexColumn'} style={{ height: showGroup === 1 ? height - 154 : 0, visibility: showGroup === 1 ? 'visible' : 'hidden' }}>
          <PartyMode height={height - 155} className={`type-regular left-bar-title flexColumn`} visible={showGroup === 1} />
        </div>

        <div className={'flexColumn'} style={{ height: showGroup === 0 ? (height - (260 + (isConnected ? Config.LEFT_MENU_CUSTOM_HEIGHT : 0) + (showInfoSection ? 120 : 0) )) : 0, visibility: showGroup === 0 ? 'visible' : 'hidden' }}>
          <FilterPlaylistsInput placeholder="Search playlists"
            className={`filter-playlists-input`} value={valueFilterPlaylist}
            onChange={onChangeValueFilterPlaylist} showIcon={true} onClear={clear}
          />
          <Playlists filter={valueFilterPlaylist} />
        </div>
      </div>
      { showInfoSection && <InformationSection /> }
      <SettingsSection />
    </div>
  )
}

ConnectedLeftBarContainer.propTypes = {
  height: PropTypes.number.isRequired,
  style: PropTypes.object,
}

const LeftBarContainer = connect(
  state => ({
    showInfoSection: ((!state.isSubscribed && state.isConnected) || !state.isConnected),
    isConnected: state.isConnected,
  })
)(ConnectedLeftBarContainer);

export default LeftBarContainer;
